export type SupportedAuthLocale = "tr" | "en" | "de";

export const authApiErrorTranslations: Record<SupportedAuthLocale, Record<string, string>> = {
  tr: {
    "E-posta veya şifre geçersiz.": "E-posta veya şifre geçersiz.",
    "E-posta veya şifre hatalı.": "E-posta veya şifre hatalı.",
    "Bu hesap bu cihazda artık tanınmıyor. Lütfen şifrenizle giriş yapın.": "Bu hesap bu cihazda artık tanınmıyor. Lütfen şifrenizle giriş yapın.",
    "Doğrulama kodu hatalı.": "Doğrulama kodu hatalı.",
    "Doğrulama kodunun süresi doldu. Yeni kod isteyin.": "Doğrulama kodunun süresi doldu. Yeni kod isteyin.",
    "Doğrulama oturumu süresi doldu. Lütfen tekrar giriş yapın.": "Doğrulama oturumu süresi doldu. Lütfen tekrar giriş yapın.",
    "Doğrulama e-postası gönderilemedi.": "Doğrulama e-postası gönderilemedi.",
    "E-posta doğrulaması tamamlanamadı.": "E-posta doğrulaması tamamlanamadı.",
    "Geçerli bir e-posta girin.": "Geçerli bir e-posta girin.",
    "Şifre en az 8 karakter olmalı.": "Şifre en az 8 karakter olmalı.",
    "Bu e-posta zaten kayıtlı.": "Bu e-posta zaten kayıtlı.",
    "Telefon numarası zorunludur.": "Telefon numarası zorunludur.",
    "Kullanıcı oluşturulamadı.": "Kullanıcı oluşturulamadı.",
    "Doğrulama kodu gerekli.": "Doğrulama kodu gerekli.",
    "Doğrulama bağlantısı geçersiz veya süresi dolmuş.": "Doğrulama bağlantısı geçersiz veya süresi dolmuş.",
  },
  en: {
    "E-posta veya şifre geçersiz.": "Email or password is invalid.",
    "E-posta veya şifre hatalı.": "Incorrect email or password.",
    "Bu hesap bu cihazda artık tanınmıyor. Lütfen şifrenizle giriş yapın.": "This account is no longer recognized on this device. Please sign in with your password.",
    "Doğrulama kodu hatalı.": "The verification code is incorrect.",
    "Doğrulama kodunun süresi doldu. Yeni kod isteyin.": "The verification code has expired. Request a new code.",
    "Doğrulama oturumu süresi doldu. Lütfen tekrar giriş yapın.": "The verification session has expired. Please sign in again.",
    "Doğrulama e-postası gönderilemedi.": "The verification email could not be sent.",
    "E-posta doğrulaması tamamlanamadı.": "Email verification could not be completed.",
    "Geçerli bir e-posta girin.": "Enter a valid email address.",
    "Şifre en az 8 karakter olmalı.": "Password must be at least 8 characters.",
    "Bu e-posta zaten kayıtlı.": "This email address is already registered.",
    "Telefon numarası zorunludur.": "A phone number is required.",
    "Kullanıcı oluşturulamadı.": "The user account could not be created.",
    "Doğrulama kodu gerekli.": "A verification code is required.",
    "Doğrulama bağlantısı geçersiz veya süresi dolmuş.": "The verification link is invalid or has expired.",
  },
  de: {
    "E-posta veya şifre geçersiz.": "E-Mail-Adresse oder Passwort ist ungültig.",
    "E-posta veya şifre hatalı.": "E-Mail-Adresse oder Passwort ist falsch.",
    "Bu hesap bu cihazda artık tanınmıyor. Lütfen şifrenizle giriş yapın.": "Dieses Konto wird auf diesem Gerät nicht mehr erkannt. Bitte melden Sie sich mit Ihrem Passwort an.",
    "Doğrulama kodu hatalı.": "Der Bestätigungscode ist falsch.",
    "Doğrulama kodunun süresi doldu. Yeni kod isteyin.": "Der Bestätigungscode ist abgelaufen. Fordern Sie einen neuen Code an.",
    "Doğrulama oturumu süresi doldu. Lütfen tekrar giriş yapın.": "Die Bestätigungssitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "Doğrulama e-postası gönderilemedi.": "Die Bestätigungs-E-Mail konnte nicht gesendet werden.",
    "E-posta doğrulaması tamamlanamadı.": "Die E-Mail-Bestätigung konnte nicht abgeschlossen werden.",
    "Geçerli bir e-posta girin.": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "Şifre en az 8 karakter olmalı.": "Das Passwort muss mindestens 8 Zeichen lang sein.",
    "Bu e-posta zaten kayıtlı.": "Diese E-Mail-Adresse ist bereits registriert.",
    "Telefon numarası zorunludur.": "Eine Telefonnummer ist erforderlich.",
    "Kullanıcı oluşturulamadı.": "Das Benutzerkonto konnte nicht erstellt werden.",
    "Doğrulama kodu gerekli.": "Ein Bestätigungscode ist erforderlich.",
    "Doğrulama bağlantısı geçersiz veya süresi dolmuş.": "Der Bestätigungslink ist ungültig oder abgelaufen.",
  },
};

export function translateAuthApiErrorMessage(
  message: string,
  locale: SupportedAuthLocale,
  fallback: string,
) {
  const normalized = message.replace(/\s+/g, " ").trim();
  if (!normalized) return fallback;
  if (locale === "tr") return authApiErrorTranslations.tr[normalized] || normalized;
  return authApiErrorTranslations[locale][normalized] || fallback;
}
